// extracted by mini-css-extract-plugin
export default {"container":"PayoutReceivedScreen_container__fbM87","icon":"PayoutReceivedScreen_icon__oYr7+"};